import { render, staticRenderFns } from "./relateData.vue?vue&type=template&id=73ae0d8c&scoped=true"
import script from "./relateData.vue?vue&type=script&lang=js"
export * from "./relateData.vue?vue&type=script&lang=js"
import style0 from "./relateData.vue?vue&type=style&index=0&id=73ae0d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ae0d8c",
  null
  
)

export default component.exports